export default __webpack_public_path__ + "static/media/logo.dcce9dfb.png";